import { FC, memo } from 'react';

import { useMediaQuery } from '@mui/material';

import { usePagePathParams } from '@hooks_common/usePagePathParams';

import ExternalLink from '@components_iqfu/public/external_link/ExternalLink';
import SectionLeadLeftAlign from '@components_iqfu/public/section_lead_left_align/SectionLeadLeftAlign';

import { MediaQuery } from '@constants_common';
import { houseRankingData, landRankingData, mansionRankingData } from 'src/iqfu/data/rankingData';

import styles from './WantToKnowRanking.module.scss';

type RankingData = {
  title: string;
  url: string;
};

const PropertyType = {
  mansion: '中古マンション',
  land: '土地',
  house: '一戸建て',
};

type Props = {
  propertyType: 'land' | 'house' | 'mansion';
};

const WantToKnowRanking: FC<Props> = memo(({ propertyType }) => {
  const isMobile = useMediaQuery(MediaQuery.lg);
  const data: RankingData[] =
    propertyType === 'land'
      ? landRankingData
      : propertyType === 'house'
      ? houseRankingData
      : propertyType === 'mansion'
      ? mansionRankingData
      : [];

  const pathParam = usePagePathParams();

  const titleYear = '2023';

  return (
    <>
      <div className={styles.lead_container}>
        <SectionLeadLeftAlign>
          {titleYear}年{PropertyType[propertyType]}を売却するときに知りたい事ランキング
        </SectionLeadLeftAlign>
      </div>
      <ul className={styles.rank_list}>
        {data.map((item, i) => (
          <li className={`${styles.rank_item} ${i === 0 ? styles.rank_item_first : ''}`} key={i}>
            <ExternalLink
              href={`${item.url}?utm_source=iqfu&utm_medium=referral&utm_campaign=${propertyType}_want_to_know_ranking&utm_content=${pathParam}`}
              target={isMobile ? '_self' : '_blank'}
              rel="noreferrer"
            >
              <span className={styles.rank_number}>{i + 1}位</span>
              {item.title}
              <span className={styles.explanation}>解説</span>
            </ExternalLink>
          </li>
        ))}
      </ul>
    </>
  );
});

WantToKnowRanking.displayName = 'WantToKnowRanking';

export default WantToKnowRanking;
